import React, { Fragment } from "react";
import { Button, ButtonGroup, Grid, ToggleButton, ToggleButtonGroup, FormHelperText } from "@mui/material";

import { useFormikContext } from "formik";

import { InputLabel } from "../../../utils/Common";

import Field from "../../../utils/FormikFields/Field";

// fieldType: "formField",
//     formFieldType: "date",
//     name: "appointment_date",
//     label: "Date",
//     type: "date",

const RecurringOption = () => {
  const { values, setFieldValue } = useFormikContext() || {};
  let { is_recurring, recurrence_pattern } = values

  const handleFrequency = (e, val) => {
    setFieldValue('recurrence_pattern.frequency', val);
  }

  return (
    <Fragment>
      <Grid size={{xs: 12, lg: 8}}>
        <InputLabel>Event Title</InputLabel>
        <Field fieldType="formField" formFieldType="text" name="title" type="text" />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        <InputLabel>Event Frequency</InputLabel>
        <Field fieldType="formField" formFieldType="switch" name="is_recurring" label="Event is recurring" type="checkbox" />
      </Grid>    
      { !is_recurring ? <Grid size={{xs: 12, lg: 4}}>
        <InputLabel>Start Date</InputLabel>
        <Field fieldType="formField" formFieldType="date" name="appointment_date" type="date" />
      </Grid> : null }
      <Grid size={{xs: 12, lg: 4}}>
        <InputLabel>Start Time</InputLabel>
        <Field fieldType="formField" formFieldType="time" name="start_time" type="time" />
      </Grid>
      <Grid size={{xs: 12, lg: 4}}>
        <InputLabel>End Time</InputLabel>
        <Field fieldType="formField" formFieldType="time" name="end_time" type="time" />
      </Grid>
      { is_recurring ? <>
        <Grid size={{xs: 12}}>
          <InputLabel>Recurring Frequency</InputLabel>
          <ToggleButtonGroup size="small" color="secondary" fullWidth value={recurrence_pattern?.frequency} exclusive onChange={handleFrequency}>
            <ToggleButton value="daily">Daily</ToggleButton>
            <ToggleButton value="weekly">Weekly</ToggleButton>
            <ToggleButton value="monthly">Monthly</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid size={{xs: 12, lg: 6}}>
          <InputLabel>Start Date</InputLabel>
          <Field fieldType="formField" formFieldType="date" name="recurrence_pattern.start_date" type="date" />
          <FormHelperText>The starting date will be the first day or date of the Recurring Schedule</FormHelperText>
        </Grid>
        <Grid size={{xs: 12, lg: 6}}>
          <InputLabel>End Date</InputLabel>
          <Field fieldType="formField" formFieldType="date" name="recurrence_pattern.end_date" type="date" />
          <FormHelperText>Cannot exceed 3 Months</FormHelperText>
        </Grid>
      </> : null }
    </Fragment>
  )
};

export default RecurringOption;